import { IndicationSummaryGetResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { indicationQueryKey } from './keys';
import { config } from '@services/config';

export const useGetIndicationSummary = (indicationId?: string, enabled = true) => {
  const client = useClient();

  return useQuery<IndicationSummaryGetResponse, Error>({
    queryKey: indicationQueryKey.getSummary({ indicationId: indicationId ?? '' }),
    queryFn: () => client.get(`indication/${indicationId}/summary`).json<IndicationSummaryGetResponse>(),
    refetchOnWindowFocus: false,
    enabled: !!indicationId && enabled,
    ...config,
  });
};
